// extracted by mini-css-extract-plugin
export default {"button":"PGWjwr","link":"Vnh_CD","mobileLink":"Dyb3iw","container":"yNs_9T","descriptionHidden":"VWE8a7","expanded":"k2w_ka"};